<script setup>
import { ref } from 'vue'
import PlansCards from '@/components/Plans/PlansCards.vue'
import Trusted from '@/components/Plans/Trusted.vue'
import Faq from '@/components/Plans/Faq.vue'
import { useConfigStore } from '@/stores/ConfigStore'
import { useBillingStore } from '@/stores/BillingStore'
import { Menu, MenuButton, MenuItems, MenuItem } from '@headlessui/vue'

const emit = defineEmits(['close'])

const configStore = useConfigStore()
const billingStore = useBillingStore()

const cancelDialogOpened = ref(false)

const openCancelDialog = _ => {
  billingStore.cancelDialogOpened = true
  billingStore.upgradeWindow = false
};
</script>
<template>
  <section class="fixed inset-0 z-[9999] bg-white flex flex-col">
    <header
        class="
          flex items-center justify-between gap-x-2 md:gap-x-6 text-gray-500 px-4 py-3 lg:px-7 lg:py-5
          flex-shrink-0 w-full bg-white z-20
        "
    >
      <div class="flex-1" />
      <Menu as="div" class="relative" v-if="!configStore.config.subscription?.will_cancel && configStore.config?.hasActiveSubscription">
        <MenuButton
          class="
            block w-fit mx-auto p-1.5 rounded-lg transition duration-300 focus:outline-none
          "
        >
          <Icon icon="heroicons:ellipsis-horizontal-20-solid" class="text-xl" />
        </MenuButton>
        <Transition name="menu-scale">
          <MenuItems
            class="
              absolute z-10 top-full mt-2 right-0 rounded-lg bg-white shadow-lg ring-1 ring-gray-200
              focus:outline-none py-1
            "
          >
            <MenuItem>
              <button
                class="flex w-max items-center gap-x-2.5 px-3.5 py-2 text-sm transition duration-300 hover:bg-gray-100"
                @click="openCancelDialog"
              >
                Cancel Subscription
              </button>
            </MenuItem>
          </MenuItems>
        </Transition>
      </Menu>
      <button @click="emit('close')" class="text-2xl transition hover:text-gray-900 p-2 lg:p-0">
        <Icon icon="heroicons:x-mark-16-solid" />
      </button>
    </header>

    <div class="flex-1 overflow-y-auto px-4 md:px-6">
      <div class="flex flex-col gap-y-6 xl:gap-y-10 max-w-[1072px] mx-auto pt-4 md:pt-8 pb-10">
        <!-- Header: Heading + Paragraph -->
        <div class="flex flex-col gap-y-2.5 text-center">
          <h1 class="text-2xl md:text-3xl xl:text-4xl font-bold">
            Upgrade your plan
          </h1>
        </div>

        <!-- Plans: Annual/Monthly tabs + Plan cards -->
        <PlansCards
          :show-annual-save-badge="true"
          page-type="upgrade-plans"
        />

        <!-- Trusted by -->
        <Trusted />

        <!-- FAQ -->
        <Faq />
      </div>
    </div>
  </section>
</template>